import { render, staticRenderFns } from "./AppAuthenticationLayout.vue?vue&type=template&id=2bc32672&"
import script from "./AppAuthenticationLayout.vue?vue&type=script&lang=ts&"
export * from "./AppAuthenticationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppAuthenticationLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports